import moment from 'moment';
import FrontendExceptionReporterService from 'modules/base/error/FrontendExceptionReporterService';

export function convertStringToDate(value, config) {
    const date = moment(value);
    if (date.isValid()) return date.toDate();
    return null;
}

export function convertDateToString(value, config) {
}